var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNostraniBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9501 30C15.2001 30.35 7.95005 27.96 6.05005 25.92C7.04005 21.39 14.2301 15.8 22.4501 12.97C23.0201 8.28996 27.4601 2.32996 35.9501 4.44996C38.7301 5.13996 40.4601 7.36996 40.9801 10.32L43.9501 12.76C43.9501 12.76 40.9701 14.08 39.3901 15.02",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9501 38.5C17.9501 39.73 17.9501 45 18.9501 46",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 42C17.09 43.24 13.9501 46 13.9501 46",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 42C19.18 43.24 22.9501 46 22.9501 46",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.51 38.5599C26.51 39.5599 28.45 43.9999 32.45 45.9999",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3401 42.4199C28.4601 44.0499 26.4501 45.9999 26.4501 45.9999",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.28 18.09C41.29 21.85 41.72 26.03 38.48 30.45C36.3 33.43 32.51 35.66 28.95 37.01C28.11 38.21 27.34 38.36 26.51 38.57C24.12 38.62 21.77 37.85 20.92 37.1C20.24 37.77 18.65 38.46 17.95 38.51C16.27 37.59 13.35 35.12 12.54 33.06",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNostraniBlack);
export default __webpack_public_path__ + "static/media/ic_nostrani_black.5cde45c39c57aa5cb5554b81d84302f4.svg";
export { ForwardRef as ReactComponent };